export default "__VITE_ASSET__CjNbYgQ5__"